import Common from './Common'
import FlowRecord from './FlowRecord'
import ControlLog from './ControlLog'

export default {
  Common,
  FlowRecord,
  ControlLog
}